import axios, { AxiosHeaders, CancelTokenSource } from 'axios';
import { getCookie } from 'cookies-next';

import EXPPopupJs from 'components/common/exp-popupjs';
import { handlePharmcareError } from './handlePharmcareError';
import { useTranslation } from 'react-i18next';
import { userDevice } from './until';
import { OptionsProps, StandardResponse } from '.';
import { clearUserLocalStorage, cryptojs } from 'helpers';

export function usePost() {
    const { t, i18n } = useTranslation(['common']);

    // const BASE_URL = process.env.REACT_APP_API_URL;
    // const userToken = getCookie('userToken', { domain: process.env.REACT_APP_DOMAIN });
    const BASE_URL = process.env.REACT_APP_API_URL;
    let userToken = getCookie('userToken', { domain: process.env.REACT_APP_DOMAIN });

    if (window.location.origin.includes('yaphrom')) {
        userToken = getCookie('userToken', { domain: process.env.REACT_APP_DOMAIN_YAPHROM });
    }
    const getValidateToken = async (redirectPath) => {
        const from = {
            path: window.location.pathname,
            params: window.location.search,
        };
        try {
            const res = await POST('/user/validateToken', {
                token: userToken,
                excludeAddress: 1,
            });
            if (res.statusCode === 200) {
                clearUserLocalStorage();
                window.location.assign(redirectPath + cryptojs.encode(from));
            }
        } catch (error) {
            console.warn('/user/validateToken error:', error);
        }
    };

    const POST = <T = any>(path: string, obj: any, formData = false, options: OptionsProps = {}) => {
        const bearer = userToken ? `Bearer ${userToken}` : '';

        const source = axios.CancelToken.source();
        if (options.setCancelToken) {
            options.setCancelToken(source);
        }

        return new Promise<StandardResponse<T>>((resolve, reject) => {
            axios({
                headers: {
                    'Content-Type': formData ? 'multipart/form-data' : 'application/json',
                    Authorization: bearer || '',
                    'User-Device': userDevice(),
                    // Multiple types, weighted with the quality value syntax:
                    // Accept-Language: fr-CH, fr;q=0.9, en;q=0.8, de;q=0.7, *;q=0.5
                    'Accept-Language': i18n?.language?.toLowerCase(), // 'en' | 'th'
                    'Referer-Path': window.location.pathname,
                    ...options.headers,
                },
                cancelToken: source.token,
                method: 'post',
                url: `${BASE_URL}${path}`,
                data: formData ? obj : { languageEn: i18n?.language?.toLowerCase() === 'th' ? 0 : 1, ...obj },
            })
                .then((res) => res.data)
                .then((json: StandardResponse<T>) => {
                    if (json.statusCode >= 301) {
                        if (path !== '/user/action') {
                            handlePharmcareError(json, reject, path, userToken ? getValidateToken : undefined);
                        } else {
                            console.log('/user/action error');
                        }
                    } else {
                        resolve(json);
                    }
                })
                .catch((error) => {
                    //  if (error instanceof Error) {
                    if (path !== '/user/action') {
                        if (path === '/misc/ui-theme-config') {
                            reject({ isError: true });
                        }
                        if (axios.isAxiosError(error)) {
                            // Axios-specific error (can access status, response, etc.)
                            console.error('Axios Error:', error.response?.data || error.message);
                            // throw error; // Re-throw or return a fallback value
                            reject({ isError: true, isNoPopup: false });
                        } else if (error.message && error.message === 'cancel') {
                            reject({ isError: true });
                        } else {
                            console.error(error);
                            EXPPopupJs.alert({
                                type: 'success',
                                icon: "<i className='fas fa-info-circle'></i>",
                                title: t('common:popup_try_again_1'),
                                message: t('common:popup_try_again_2'),
                                classNames: { message: 'font-detail2' },
                                buttons: [
                                    {
                                        label: t('common:popup_try_again_3'),
                                        variant: 'primary',
                                        action: ({ close }) => {
                                            close();
                                        },
                                    },
                                ],
                            });
                        }
                    }
                });
        });
    };

    return POST;
}
